import { BASE_URL } from "@/constants/endpoints";
import { DriverDetail } from "@/pages/config/drivers/schema/drivers.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let DriversApiPromise: Promise<AxiosInstance> | null = null;

const getDriversApi = async (): Promise<AxiosInstance | null> => {
  if (DriversApiPromise) return DriversApiPromise;
  DriversApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return DriversApiPromise;
};

export interface GetDriversListProps {
  nombreApellido?: string;
  equipos: number[]
  activo?: boolean;
  "P.Pagina": number;
  "P.Records"?: number;
}

export const getDriversList = async (props: GetDriversListProps) => {
  const api = await getDriversApi();
  if (!api) return;

  const response = await api.get(
    `/Choferes/All?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetDriverProps {
  id: number;
}

export const getDriver = async (props: GetDriverProps): Promise<DriverDetail | null> => {
  const api = await getDriversApi();
  if (!api) return null;

  const response = await api.get(`/Choferes/${props.id}`);

  return response.data;
};

export interface DeleteDriversProps {
  Ids: number[];
}

export const deleteDrivers = async (props: DeleteDriversProps) => {
  const api = await getDriversApi();
  if (!api) return;

  const response = await api.delete(
    `/Choferes?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateDriverProps {
  usuario: string,
  nombreApellido: string,
  email: string,
  equipos: number[]
}

export const createDriver = async (props: CreateDriverProps) => {
  const api = await getDriversApi();
  if (!api) return;

  const response = await api.post(`/Choferes`, props);

  return response.data;
};

export interface UpdateDriverProps {
  id: number;
  activo: boolean
  equipos: number[]
}

export const updateDriver = async (props: UpdateDriverProps) => {
    const api = await getDriversApi();
  if (!api) return;

  const response = await api.patch(`/Choferes`, props);

  return response.data;
}